import React, { useState } from 'react'
import { Flex } from 'ui/acro'
import styled from 'styled-components'
import { Button } from 'ui/bend'
import EventCard from './Cards/EventGridCard'

const Container = styled(Flex)({
  flexDirection: 'column',
  gap: '30px'
})

const MOBILE_LIMIT = 3

const MoreEventsMobile = ({
  events,
  section,
  totalCount,
  loadNextPageData,
  currentPage,
  ...rest
}) => {
  const [expanded, setExpanded] = useState(false)

  const visibleItems = expanded ? events : events.slice(0, MOBILE_LIMIT)

  const handleViewMore = () => {
    setExpanded(true)
    if (
      parseInt(totalCount) > events.length &&
      visibleItems.length === events.length
    ) {
      loadNextPageData({ section: section, pageNumber: currentPage + 1 })
    }

    if (parseInt(totalCount) === visibleItems.length) {
      setExpanded(false)
    }
  }
  return (
    <Container>
      {visibleItems.map((item, index) => (
        <EventCard
          {...item}
          location='related'
          position={index + 1}
          key={item?.id || index}
        />
      ))}

      {parseInt(totalCount) > MOBILE_LIMIT && (
        <Button
          onClick={() => handleViewMore()}
          height='24px'
          width='100%'
          mt='24px'
          variant='ouline'
          style={{
            fontSize: '16px',
            fontWeight: 500,
            color: '#000',
            cursor: 'pointer'
          }}
        >
          {parseInt(totalCount) === visibleItems.length
            ? 'View Less'
            : 'Show All'}
        </Button>
      )}
    </Container>
  )
}
export default MoreEventsMobile
